/*import React from 'react'
import Helmet from 'react-helmet'

const ProductsServicesEn = () => (
  <div className="page products_services">
  <Helmet
            title={`Budget Nicaragua Products & services - Find a Car Rental Near You`}
            meta={[
              {
                name: 'description',
                content:
                  'Frequently Asked Questions about car rentals.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'en',
                href:
                  './es/products-services',
              },
            ]}
          />

    <div className="image"></div>
    <h1>Products & Services</h1>
    <div className="wrapper">
      <div className="block-first">
        
        <ul>
          <li>
           <h3>Free Tourist Map</h3>
           With the rental we give you an updated free tourist map.
          </li>
          <li>
           <h3>Technical and Legal Assistance</h3>
           Technical and Legal Assistance 24 hours
           Budget offers 24 hours protection in case you have a collision, 
           and/or have mechanical or legal problems regarding your rental.
           Our emergency numbers are: <a href="tel:+50588561509">8856-1509</a> / <a href="tel:+50522789568">(505) 2278 9568</a>
          </li>
          <li>
           <h3>Professional Drivers Service</h3>
           We have a professional crew of drivers just in case you do not feel like driving around. 
           Even though they are independent contractors we recommend them for their sense of service 
           and professional ability.
          </li>
          <li>
            <h3>GPS Rental</h3>
            Budget has the latest in GPS technology at your service. Ask at our Reservation Department or 
            in our counter about the GPS.
            It works in Nicaragua as well as in Costa Rica.
          </li>

          <li>
            <h3>Child Safety Chairs</h3>
            At BUDGET we care about the safety of our customers, especially when it comes to children. 
            For this reason we have available child safety seats, which can be rented, in all our branches. 
            This service requires your advance request, to guarantee the effectiveness of it.
          </li>

        </ul>
      </div>
    </div>
  </div>
)
export default ProductsServicesEn

*/


import React, { Component } from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'


class ProductsServicesEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      descriptionEn: '',
    }

    this.renderTextsProgram = this.renderTextsProgram.bind(this)

    
  }
  componentDidMount() {


      axios
      .get(`${backendURL}/api/texts/sections/TextProgram/Main`)  
      .then(res => {

        const txt = res.data;

        console.log(txt);

        this.setState({     
          descriptionEn:{
            en: txt.descriptionEn,
          }, 
        })
        })

     

      .catch(err => {
        console.log(err)
      })
  }


  renderTextsProgram() {
    const { texts } = this.state
    return _.map(texts, (text, i) => {
      const { descriptionEn , published } = text
      //const { langKey: lang } = this.props.pathContext
      console.log(text);
      if (published) {
        return (
          <div key={i}>
          <p> 
            {descriptionEn.en} 
          </p>
          </div>
        )
        return null
      }
    })
  } 


  render() {
    return (
      <div className="page corporate_program">
      <Helmet
         title={`Corporate Program |  Budget Guatemala`}
         meta={[
           {
             name: 'description',
             content:
               'Frequently Asked Questions about car rentals.',
           },
         ]}
         link={[
           {
             rel: 'alternate',
             hreflang: 'en',
             href:
               './es/corporate_program',
           },
         ]}
       />
       <div className="image"></div>
       <h1>Products & Services</h1>
    <div dangerouslySetInnerHTML={{__html: this.state.descriptionEn.en}}></div>
</div>
    )
  }
}
export default ProductsServicesEn


// WEBPACK FOOTER //
// ./src/pages/products-services.en.js